export const AUTH_METHOD_NONE = 'none'
export const AUTH_METHOD_BASIC = 'basic'
export const AUTH_METHOD_TOKEN_BASED = 'token_based'
